import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AlphaEditorPage } from "@/features/request/alpha";
import { requireAlphaFeatureFlag } from "@/lib/posthog-flags";

const alphaEditorSearchSchema = z.object({
  version: z.string().optional(),
});

export const Route = createFileRoute(
  "/_auth/_app-shell/requests/$requestId/alpha_/designs/$designId/edit",
)({
  beforeLoad: requireAlphaFeatureFlag,
  component: AlphaEditorPage,
  params: {
    parse: (rawParams) => ({
      designId: String(rawParams["designId"]),
      requestId: Number(rawParams["requestId"]),
    }),
  },
  validateSearch: alphaEditorSearchSchema,
});
